import { Button, Flex, MultiSelect, Select, Switch, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { CHART_DUR, NumOfBsd, NumOfGroup } from "CommonData"; // src/CommonData.js
import SRD_Chart from "components/Chart";
import Layout from "components/Layout";
import { getBsdList } from "pages/Admin/Device/apis/adminDeviceApis";
import { getGroupList } from "pages/Admin/Group/apis/adminGroupApis";
import { userState } from "pages/Login/atom/userState";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import LoadSpinner from "utils/LoadSpinner";
import Indexdygraph from '../../components/Chart/dyGraph/Indexdygraph';
import { getChartData, getStatus } from "./apis/chart";


function Chart() {
  const [user] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const adminLevel = [0].includes(level);
  const loginGroupId = adminLevel ? null : user?.fn_group_id;

  const [group, setGroup] = useState(loginGroupId);
  const [bsd, setBsd] = useState();
  const [range, setRange] = useState({
    start: new Date(new Date().getTime() - CHART_DUR * 24 * 60 * 60 * 1000),
    end: new Date(),
  });

  const [reChart, setRechart] = useState(true);
  
  useEffect(() => {
    setRange((prevRange) => {
      const newEnd = new Date(
        prevRange.start.getTime() + CHART_DUR * 24 * 60 * 60 * 1000
      );
      return {
        ...prevRange,
        end: newEnd > new Date() ? new Date() : newEnd,
      };
    });
  }, [range.start]);

  const [bsdList, setBsdList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [searchPressed, setSearchPressed] = useState(false);

  const [deviceStatusList, setDeviceStatusList] = useState([]);
  const [deviceStatusValue, setDeviceStatusValue] = useState();
  const [requestChartList, setRequestChartList] = useState();
  const [transformedList, setTransformedList] = useState([]);

  const dateToString = (date) => {
    const isoDate = date.toISOString(); // "2023-04-24T06:21:49.123Z"
    const formattedDate = isoDate.slice(0, 10).replace(/-/g, ""); //"20230424"
    return formattedDate;
  };

  useEffect(() => {
    getGroupList(NumOfGroup, 1).then((groupList) => {
      const formattedGroupList = groupList.map((item) => ({
        value: item.group_id,
        label: item.group_nm,
      }));

      setGroupList(formattedGroupList);
    });
  }, []);

  useEffect(() => {
    group &&
      getBsdList(NumOfBsd, 1, group).then((bsdList) => {
        const filteredList = bsdList.filter((item) => item.group_id === group);
        const formattedBsdList = filteredList.map((item) => ({
          value: item.bsd_id,
          label: item.bsd_nm,
        }));
        setBsdList(formattedBsdList);
      });
  }, [group]);

  useEffect(() => {
    if (bsd) {
      const fetchData = async () => {
        try {
          const statusResponse = await getStatus(bsd);
          // console.log("CHANNEL>statusResponse.length:", statusResponse.length);

          setDeviceStatusList(
            statusResponse.map((item) => ({
              value: item.bsd_sttus_id,
              label: item.chnnl_nm,
            }))
          );
        } catch (error) {
          console.error("Error fetching status:", error);
        }
      };
      fetchData();
    }
  }, [bsd]);
  
  const [queryReq, setqueryReq] = useState(false);
  const onClick = async () => {
    setqueryReq(true);
    setSearchPressed(true);
    setDeviceStatusValue(deviceStatusValue);

    const transformedList = deviceStatusValue?.map((item) => {
      const parsedItem = parseInt(item);
      const chnnlNm =
        deviceStatusList.find((res) => res.value === item)?.label || "";
      let cleanedChnnlNm = "";
      cleanedChnnlNm = chnnlNm.replace(/.*?_/, ""); // "53_대기습도"를 "대기습도"로 변환함
      return {
        bsdSttusId: `${parsedItem}`,
        chnnlNo: `D${parsedItem}`,
        chnnlNm: cleanedChnnlNm,
      };
    });

    setTransformedList(transformedList);

    try {
      const getChartList = await getChartData(
        dateToString(range.start),
        dateToString(range.end),
        transformedList
      );
      if (getChartList !== undefined && (typeof getChartList !== 'string')) {
        setRequestChartList(getChartList);
        setqueryReq(false);
        // console.log("CHANNEL>getChartList.length:", getChartList.length);
        // console.log("CHANNEL>requestChartList.length:", requestChartList.length);
        // const jsonData = JSON.stringify(requestChartList);
        // const jsonBlob = new Blob([jsonData], { type: 'application/json' });
        // const link = document.createElement('a');
        // link.href = URL.createObjectURL(jsonBlob);
        // link.download = 'chart_data.json';
        // link.click();
      } else {
        alert("표시할 차트 데이터가 없습니다.");
      }
    } catch (error) {
      console.error("Error occurred while fetching chart data:", error);
      // alert("차트 데이터를 가져오는 중 오류가 발생했습니다.");
    }
  };

  /*
  const [dispUnit, setDispUnit] = useState("minute");

  const handleRadioChange = (e) => {
    setDispUnit(e.target.value);
    // console.log(dispUnit);
  };
  */

  const SearchBar = () => {
    const handleStartChange = (date) => {
      setRange((prevState) => ({ ...prevState, start: date }));
    };
    const handleEndChange = (date) => {
      setRange((prevState) => ({ ...prevState, end: date }));
    };

    /*
    const currentDate = new Date();
    const todayFormattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    */

    return (
      <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
        <Flex gap={15} mb={10} width="100%" align="center" wrap="wrap">
          <Select
            disabled={!adminLevel}
            data={groupList ?? []}
            value={group}
            placeholder="그룹 선택"
            onChange={setGroup}
          />
          <Select
            data={bsdList ?? []}
            value={bsd}
            placeholder="분사 장치 선택"
            onChange={setBsd}
          />
          <Text fw={500}>시작일</Text>
          <DateInput
            value={range.start}
            w={120}
            onChange={handleStartChange}
            valueFormat="YYYY년 MM월 DD일"
            inputProps={{
              rightSection: <i className="fas fa-calendar-alt"></i>,
              inputformat: "YYYY-MM-DD" 
            }}
            maxDate={new Date()}
          />
          <Text fw={500}>종료일</Text>
          <DateInput
            value={range.end}
            w={120}
            onChange={handleEndChange}
            valueFormat="YYYY년 MM월 DD일"
            inputProps={{
              rightSection: <i className="fas fa-calendar-alt"></i>,
              inputformat: "YYYY-MM-DD" 
            }}
            minDate={range.start}
            maxDate={new Date(Math.min(range.start.getTime() + CHART_DUR * 24 * 60 * 60 * 1000, new Date().getTime()))}
          />
          <Button onClick={onClick}>조회</Button>
          <Switch onLabel="reChart" offLabel="dyGraph"
                                size="md"
                       //         label="차트" 
                                color="gray"
                                checked={reChart} 
                                onChange={(e) => setRechart(e.currentTarget.checked)}
        /> 
        </Flex>
        <div>
          <Flex gap={15} justify-content="flex-start" align="center" style={{ direction: 'ltr' }}>
            <MultiSelect
              w={1000}
              data={deviceStatusList}
              placeholder="항목 선택"
              value={deviceStatusValue}
              onChange={setDeviceStatusValue}
              limit={10}
              clearButtonProps={{ "aria-label": "Clear selection" }}
              clearable
            />
          </Flex>
        </div>
      </div>
    );
  };

  return (
    <Layout title="차트">
    { reChart ?  (
      <>
      <div style={{ overflowX: 'overlay', direction: 'ltr' }}></div>
      <SearchBar />
      {requestChartList && requestChartList.length > 0 && (
        <SRD_Chart
          chartData={requestChartList}
          transformedList={transformedList}
          searchButton={searchPressed}
        />
      )}
      </> )
    : ( 
      <>
        <SearchBar />
        <div>
          { queryReq && LoadSpinner()}
        </div>
        <Indexdygraph data={requestChartList} />
      </> 
    )
   }  
    </Layout>
  );
}

export default Chart;
